import React from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import makeUrl from "../../utils/UrlMaker.js";
import { getConfigValue } from "../../utils/config";

function PrivateRoute(props) {
    if (!props.isAuthenticated) {
        if (!!getConfigValue("authProviderUrl")) {
            return (
                <>
                    <div style="display: none;">
                    {
                        (window.location.href = makeUrl(
                            "authProviderUrl",
                            `/connect/authorize?` +
                            `response_mode=form_post&` +
                            `grant_type=code&scope=openid offline_access&` +
                            `client_id=${getConfigValue("ClientId")}&` +
                            `response_type=code&` +
                            `redirect_uri=${encodeURIComponent(
                                getConfigValue("RedirectUri")
                            )}`
                        ))
                    }
                    </div>
                </>
            );
        }
        else return <><div style="display: none;">{(window.location.href = "#/signin")}</div></>;
    }
    return props.forRole === props.currentUserRole ? (
        <Route {...props}>{props.children}</Route>
    ) : (
        <>403 niewystarczajace uprawnienia</>
    );
}

PrivateRoute.propTypes = {
    isAuthenticated: PropTypes.bool,
    currentUserRole: PropTypes.string,
    forRole: PropTypes.string,
};

PrivateRoute.defaultProps = {
    isAuthenticated: false,
    currentUserRole: "all",
    forRole: "all",
};

export default PrivateRoute;
